import {
    STOCK_TAKING_CAR_MANAGEMENT_LOCATIONS_DATA_MASTER_BEGIN,
  } from '../constants';
  
  export function getLocationsDataMaster(branchOfficeId) {
    return (dispatch) => {
      dispatch({
        type: STOCK_TAKING_CAR_MANAGEMENT_LOCATIONS_DATA_MASTER_BEGIN,
        data: {branchOfficeId}
      })
    }
  }